import React, { useState, useEffect } from 'react';
import styled from 'styled-components'; 

const StyledFooter = styled.footer`
  text-align: center;
  padding: 1rem;
  background: ${({ theme }) => theme.footerBg}; /* Use theme.footerBg */
  color: ${({ theme }) => theme.footerText};   /* Use theme.footerText */
`;

export default function Footer() {
  const [lastUpdated, setLastUpdated] = useState('');

  useEffect(() => {
    setLastUpdated(document.lastModified);
  }, []);

  return (
    <StyledFooter>
      © {new Date().getFullYear()} Yellow Ray Consulting Group Inc.<br />
      Last updated: {lastUpdated}
    </StyledFooter>
  );
}